var React = require('react');

function Export (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"miter","strokeLinecap":"square"},[React.createElement("path",{"d":"M1.5 1.5h10","key":0}),React.createElement("path",{"d":"M13.36 7.64L19.5 1.5","key":1}),React.createElement("path",{"d":"M19.5 5.5v-4","key":2}),React.createElement("path",{"d":"M15.5 1.5h4","key":3}),React.createElement("path",{"d":"M1.5 1.5v18M1.5 19.5h18M19.5 19.5v-10","key":4})]));
}

Export.defaultProps = {"width":"21","height":"21"};

module.exports = Export;

Export.default = Export;



//////////////////
// WEBPACK FOOTER
// ./src/icons/export.svg
// module id = 899
// module chunks = 0